import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import LogInButton from 'flarum/forum/components/LogInButton';
import extractText from 'flarum/common/utils/extractText';
import Tooltip from 'flarum/common/components/Tooltip';
/**
 * Build the OAuth authorization URL for a given provider path.
 * Appends returnTo so the server can redirect back after auth.
 */
function oauthUrl(path) {
  const base = app.forum.attribute('baseUrl');
  const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
  return "".concat(base).concat(path, "?returnTo=").concat(returnTo);
}
export default function () {
  // Replace the popup onclick with a full-page navigation.
  override(LogInButton, 'initAttrs', function (original, attrs) {
    original(attrs);

    // Override whatever onclick the parent set — we navigate instead of opening a popup.
    attrs.onclick = function (e) {
      e.preventDefault();
      window.location.href = oauthUrl(attrs.path);
    };
  });
  extend(LogInButtons.prototype, 'items', function (items) {
    var _app$forum$attribute$, _app$forum$attribute;
    const onlyIcons = app.forum.attribute('fof-oauth.only_icons');
    const enabledOAuthProviders = (_app$forum$attribute$ = (_app$forum$attribute = app.forum.attribute('fof-oauth')) == null ? void 0 : _app$forum$attribute.filter(provider => provider !== null)) != null ? _app$forum$attribute$ : [];
    enabledOAuthProviders.forEach(_ref => {
      let {
        name,
        icon,
        priority
      } = _ref;
      let className = "Button FoFLogInButton LogInButton--".concat(name);
      if (onlyIcons) {
        className += ' Button--icon';
      }
      items.add(name, m("div", {
        className: "LogInButtonContainer LogInButtonContainer--".concat(name)
      }, m(LogInButton, {
        className: className,
        icon: icon,
        path: "/auth/".concat(name)
      }, app.translator.trans("fof-oauth.forum.log_in.with_".concat(name, "_button"), {
        provider: app.translator.trans("fof-oauth.forum.providers.".concat(name))
      }))), priority);
    });
  });
  override(LogInButton.prototype, 'view', function (original, vnode) {
    const onlyIcons = app.forum.attribute('fof-oauth.only_icons');
    if (!onlyIcons) return original(vnode);
    const child = original(vnode);

    // @ts-ignore
    return m(Tooltip, {
      text: extractText(child.children[1])
    }, child);
  });
  extend(LogInButtons.prototype, 'view', function (vdom) {
    const onlyIcons = app.forum.attribute('fof-oauth.only_icons');
    if (!onlyIcons) return;

    // @ts-ignore
    vdom.attrs.className += ' FoFLogInButtons--icons';
  });
  extend('flarum/forum/components/SignUpModal', 'fields', function (items) {
    // If a suggested username was not provided by the OAuth service, display help text.
    if (!!this.attrs.token && !this.attrs.username) {
      items.add('username-help', m("div", null, m("p", null, app.translator.trans('fof-oauth.forum.signup.username_help'))), 35);
    }
  });
}